module.exports = {
  THEMES_WITH_TRANSPARENT_HEADER: ['home_deco', 'fashion', 'sports', 'toys'],
};
